import Dashboard from '@/components/Dashboard/'
import Buyers from '@/components/Buyers/'
// import CustomerDeposit from '@/components/Buyers/CustomerDeposit/'
import CustomerDeposit from '@/components/Buyers/CustomerDeposit/customerDeposite.vue'

import Settings from '@/components/Settings/'
import Reports from '@/components/Reports/'
import MonthlyStockReports from '@/components/Reports/MonthlyReports'
import Items from '@/components/Items/'
import InvoiceManagement from '@/components/InvoiceManagement/'
import Informations from '@/components/Informations'
import Products from '@/components/Products/product.vue'
import Transactions from '@/components/Transactions/transfer.vue'
import IST from '@/components/IST/index.vue'
import Godawns from '@/components/Godawn/godawn.vue'
import GodownReports from '@/components/GodownReports/GodownReports.vue'
import Offshoots from '@/components/Offshoot/offshoot.vue'

import RecordDelivery from '@/components/RecordDelivery/recordDelivery.vue'
import RecordDispatch from '@/components/RecordDispatch/recordDispatch.vue'
import RecordEstimate from '@/components/RecordEstimate/recordEstimate.vue'
import RecordLead from '@/components/RecordLead/RecordLead.vue'
import RecordOrder from '@/components/RecordOrder/recordOrder.vue'
import Staffs from '@/components/Staffs/staff.vue'


import InvoiceStatements from '@/components/Buyers/Buyer/BuyerStatements'

import GST1Reports from '@/components/GSTReports/gst1'
import GST3Reports from '@/components/GSTReports/gst3'
import GSTMonthly from '@/components/GSTReports/gstMonthly'

import FirmStatements from '@/components/Firms/invoiceList.vue'
import BankStatements from '@/components/BankStatements/invoiceList.vue'
import CashStatements from '@/components/CashStatements/invoiceList.vue'

import InvoiceHistory from '@/components/Buyers/InvoiceHistory/'
import RemainingBalance from '@/components/Buyers/RemainingBalance/RemainingBalance.vue'
import QuickInvoice from '@/components/Quick/Invoice/quickInvoice.vue'
import InvoiceUpdate from '@/components/Quick/Invoice/invoiceUpdate.vue'
import DailyTransactionBook from '@/components/DailyTransactions/index.vue'
import SalePurchaseStatements from '@/components/SalePurchaseStatements/invoiceList.vue'
import CustomerPayments from '@/components/Buyers/CustomerPayments/customerPayments.vue'
import ProductReports from '@/components/ProductReports/ProductReports.vue';
import PortfolioManagement from '@/components/PortfolioManagement/PortfolioManagement.vue';
import ReceiptRegister from '@/components/ReceiptRegister/receiptList.vue';
import PaymentRegister from '@/components/PaymentRegister/paymentList.vue';
import ReceiptCollection from '@/components/ReceiptCollection/ReceiptCollection.vue';

import LandingPage from '@/components/LandingPage/homePage.vue'
import BuyerRoutes from './buyers/'
import SettingRoutes from './settings/'
import ReportRoutes from './reports/'
import PermissionDenied from '@/components/PermissionDenied/PermissionDenied.vue';
import store from '../../store';


// import Items from './items/'
import InformationRoutes from './informations/'
// import InvoiceRoutes from './invoices/'

export default [{
  path: '/dashboard',
  name: 'Dashboard',
  component: Dashboard,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_DASHBOARD')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
}, 
{
  path: '/reports',
  name: 'Reports',
  component: Reports,
  children: ReportRoutes,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_RECORDS')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
}, 
{
  path: '/reports/:reportType',
  name: 'ReportsWithType',
  component: Reports,
  children: ReportRoutes,
  meta: {requiresAuth: true}
},
{
  path: '/invoicemanagement',
  name: 'InvoiceManagement',
  component: InvoiceManagement,
  // children: InvoiceRoutes,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_TRANSACTIONS')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
},
{
  path: '/invoicemanagement/:type',
  name: 'InvoiceManagementWithType',
  component: InvoiceManagement,
  // children: InvoiceRoutes,
  meta: {requiresAuth: true}
},
{
  path: '/buyers',
  name: 'Buyers',
  component: Buyers,
  children: BuyerRoutes,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_BUYER')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
}, 
{
  path: '/settings',
  name: 'Settings',
  component: Settings,
  children: SettingRoutes,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_SETTINGS')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
}, 
{
  path: '/items',
  name: 'Items',
  component: Items,
  meta: {requiresAuth: true}
}, 
{
  path: '/informations',
  name: 'Informations',
  component: Informations,
  children: InformationRoutes,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_REPORTS')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
},
{
  path: '/products',
  name: 'Products',
  component: Products,
  meta: {requiresAuth: true},
  beforeEnter: (to, from, next) => {
    let rolesAndPermissions = store.getters['Global/roleAndPermission'];
    if(rolesAndPermissions && 
      rolesAndPermissions.permissions && 
      rolesAndPermissions.permissions.length && 
      rolesAndPermissions.permissions.indexOf('BRAND_PRODUCTS')>-1) {
      next();
    } else {
      next('/permission-denied');
    }
  },
},
{
  path: '/transfer',
  name: 'Transactions',
  component: Transactions,
  meta: {requiresAuth: true}
},
{
  path: '/products/:isNew',
  name: 'ProductsWithNew',
  component: Products,
  meta: {requiresAuth: true}
},
{
  path: '/products/:isNew/:redirect',
  name: 'ProductsWithRedirect',
  component: Products,
  meta: {requiresAuth: true}
},
{
  path: '/customer-deposit/:customerId',
  name: 'CustomerDeposit',
  component: CustomerDeposit,
  meta: {requiresAuth: true}
},
{
  path: '/customer-payments/:customerId',
  name: 'CustomerPayments',
  component: CustomerPayments,
  meta: {requiresAuth: true}
},{
  path: '/montly-stock-reports',
  name: 'MonthlyStockReports',
  component: MonthlyStockReports,
  meta: {requiresAuth: true}
},{
  path: '/ist',
  name: 'IST',
  component: IST,
  meta: {requiresAuth: true}
},{
  path: '/invoice-history/:invoiceId',
  name: 'InvoiceHistory',
  component: InvoiceHistory,
  meta: {requiresAuth: true}
},{
  path: '/invoice-statements/:customerId',
  name: 'InvoiceStatements',
  component: InvoiceStatements,
  meta: {requiresAuth: true}
},{
  path: '/gst1-reports',
  name: 'GST1Reports',
  component: GST1Reports,
  meta: {requiresAuth: true}
}, {
  path: '/gst3-reports',
  name: 'GST3Reports',
  component: GST3Reports,
  meta: {requiresAuth: true}
},
{
  path: '/gst-monthly',
  name: 'GSTMonthly',
  component: GSTMonthly,
  meta: {requiresAuth: true}
}, 
// {
//   path: '/firm-statements/:firmId',
//   name: 'FirmStatements',
//   component: FirmStatements,
//   meta: {requiresAuth: true}
// }, 
{
  path: '/remaining-balance/:customerId',
  name: 'RemainingBalance',
  component: RemainingBalance,
  meta: {requiresAuth: true}
}, 
{
  path: '/godawn',
  name: 'Godawns',
  component: Godawns,
  meta: {requiresAuth: true}
},
{
  path: '/godown-reports',
  name: 'GodownReports',
  component: GodownReports,
  meta: {requiresAuth: true}
},
{
  path: '/offshoot',
  name: 'Offshoots',
  component: Offshoots,
  meta: {requiresAuth: true}
},
{
  path: '/staffs',
  name: 'Staffs',
  component: Staffs,
  meta: {requiresAuth: true}
},
{
  path: '/lead-record',
  name: 'RecordLead',
  component: RecordLead,
  meta: {requiresAuth: true}
},
{
  path: '/recordOrder',
  name: 'RecordOrder',
  component: RecordOrder,
  meta: {requiresAuth: true}
},
{
  path: '/recordEstimate',
  name: 'RecordEstimate',
  component: RecordEstimate,
  meta: {requiresAuth: true}
},
{
  path: '/dispatch-register',
  name: 'RecordDispatch',
  component: RecordDispatch,
  meta: {requiresAuth: true}
},
{
  path: '/delivery-register',
  name: 'RecordDelivery',
  component: RecordDelivery,
  meta: {requiresAuth: true}
},
{
  path: '/quick-invoice',
  name: 'QuickInvoice',
  component: QuickInvoice,
  meta: {requiresAuth: true}
},
{
    path: '/order-to-invoice/:orderId',
    name: 'QuickInvoice',
    component: QuickInvoice,
    meta: {requiresAuth: true}
},
{
  path: '/portfolio-to-invoice/:orderId',
  name: 'QuickInvoice',
  component: QuickInvoice,
  meta: {requiresAuth: true}
},
{
  path: '/invoice-create/:customerId/:isBuyer',
  name: 'QuickInvoice',
  component: QuickInvoice,
  meta: {requiresAuth: true}
},
{
  path: '/estimate-to-invoice/:estimateId',
  name: 'QuickInvoice',
  component: QuickInvoice,
  meta: {requiresAuth: true}
},
{
  path: '/update-invoice/:invoiceId',
  name: 'InvoiceUpdate',
  component: InvoiceUpdate,
  meta: {requiresAuth: true}
},
{
  path: 'daily-transaction-book',
  name: 'DailyTransactionBook',
  component: DailyTransactionBook,
  meta: {requiresAuth: true}
},      
{
  path: '/landingPage',
  name: 'LandingPage',
  component: LandingPage,
  children: ReportRoutes,
  meta: {requiresAuth: true}
},
{
  path: '/firm-statements/:firmId',
  name: 'FirmStatements',
  component: FirmStatements,
  meta: {requiresAuth: true}
},
{
  path: '/bank-statements/:bankId',
  name: 'BankStatements',
  component: BankStatements,
  meta: {requiresAuth: true}
},
{
  path: '/cash-statements',
  name: 'CashStatements',
  component: CashStatements,
  meta: {requiresAuth: true}
},
{
  path: '/sale-register/:month/:date',
  name: 'SalePurchaseStatements',
  component: SalePurchaseStatements,
  meta: {requiresAuth: true}
},   
{
  path: '/purchase-register/:month/:date',
  name: 'SalePurchaseStatements',
  component: SalePurchaseStatements,
  meta: {requiresAuth: true}
},
{
  path: '/product-report',
  name: 'ProductReports',
  component: ProductReports,
  meta: {requiresAuth: true}
},
{
  path: '/sale-register',
  name: 'SalePurchaseStatements',
  component: SalePurchaseStatements,
  meta: {requiresAuth: true}
},   
{
  path: '/purchase-register',
  name: 'SalePurchaseStatements',
  component: SalePurchaseStatements,
  meta: {requiresAuth: true}
},
{
  path: '/portfolio-management',
  name: 'PortfolioManagement',
  component: PortfolioManagement,
  meta: {requiresAuth: true}
},
{
  name: 'PermissionDenied',
  path: '/permission-denied',
  component: PermissionDenied,
  meta: {requiresAuth: true}
},
{
  path: '/receipt-register',
  name: 'ReceiptRegister',
  component: ReceiptRegister,
  meta: {requiresAuth: true}
},
{
  path: '/payment-register',
  name: 'PaymentRegister',
  component: PaymentRegister,
  meta: {requiresAuth: true}
},                 
{
  path: '/receipt-collection',
  name: 'ReceiptCollection',
  component: ReceiptCollection,
  meta: {requiresAuth: true}
},
]



// WEBPACK FOOTER //
// ./src/router/home/index.js